import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ActiveBooking } from '../../../../vehicle-details';

@Component({
  selector: 'operation-card',
  imports: [TranslateModule],
  standalone: true,
  templateUrl: './operation-card.component.html'
})
export class OperationCardComponent {
  @Input() booking!: ActiveBooking;
}
